export default __webpack_public_path__ + "static/media/extra.8a071b0a.svg";